import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useUserContext } from '@contexts/UserContext/UserProvider';
const PreventedRoute = ({ component: Component, ...rest }) => {
  const { token } = useUserContext();

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? <Redirect to="/" /> : <Component {...props} />
      }
    />
  );
};

export default PreventedRoute;
